import { ArrowForward, Check } from '@material-ui/icons';
import { MetricCard, MetricCardPlaceholder } from 'src/components/shared/MetricCard';
import { theme } from '@evgo/react-material-components';
import { Link } from 'react-router-dom';
import { useListChargersV2ShallowQuery } from 'src/@types';
import { colors } from '@material-ui/core';
import { LabelDiv } from '../styles';
import useAnalytics from 'src/lib/hooks/useAnalytics';
import { events } from 'src/lib/utils/analytics-events';
import config from 'src/config';

export const ChargersWithoutPricingCard = () => {
  const { track } = useAnalytics();

  const chargersWithoutPricingInput = {
    pageSize: config.maxPageSize,
    filter: {
      tariffId: { eq: null },
    },
  };

  const { data: chargersWithoutPricingData, loading: chargersWithoutPricingLoading } = useListChargersV2ShallowQuery({
    variables: {
      input: chargersWithoutPricingInput,
    },
    fetchPolicy: 'network-only',
  });
  const chargersWithoutPricingCount = chargersWithoutPricingData?.listChargersV2?.total || 0;
  const loading = chargersWithoutPricingLoading;
  const hasChargersWithoutPricing = chargersWithoutPricingCount > 0;
  const primaryTextColor = hasChargersWithoutPricing ? colors.red[600] : theme.palette.text.primary;
  const labelTextColor = hasChargersWithoutPricing ? theme.palette.text.primary : colors.green[600];

  const MetricLabel = hasChargersWithoutPricing ? (
    <Link
      to={`/extend-plus/charger-prices`}
      onClick={() => {
        track(events.dashboardView.CLICKED_ASSIGN_PRICE);
      }}
    >
      <LabelDiv>
        <span>ASSIGN A PRICE</span>
        <ArrowForward />
      </LabelDiv>
    </Link>
  ) : (
    <LabelDiv>
      <Check />
      <span>ALL CHARGERS HAVE A PRICE</span>
    </LabelDiv>
  );

  return (
    <>
      {loading ? (
        <MetricCardPlaceholder data-testid="metricCard-chargers-without-pricing-loading" />
      ) : (
        <MetricCard
          className="metric-card"
          primaryText={chargersWithoutPricingCount}
          theming={{ primaryTextColor, labelTextColor }}
          secondaryText="Without Pricing"
          label={MetricLabel}
          data-testid="metricCard-chargers-without-pricing"
        />
      )}
    </>
  );
};
